import React from 'react'
export default class InputComp extends React.Component{
  constructor (props) {
      super (props)
      this.state = ({
        value:0
      })
      this.InputVal = this.InputVal.bind(this)
      this.state= {value:props.value}
  }

  InputVal (e){
    e.preventDefault()
    // let value = e.target.value
    // console.log(value);
    // this.setState({value})
    this.props.onChange_(e)
  }
  render () {
    // console.log(this.props.value)
    return <input name={this.props.name} key="123" value={this.props.value} onChange={this.InputVal}/>
  }
}



// WEBPACK FOOTER //
// ./src/components/Patient/SuperMedicalMix/InputComp.js